/* --------------------------------------------------------------------------
   Datumfälten: tolkning och kalenderns månad

   Datumfälten är vanliga textfält med ÅÅÅÅ-MM-DD och en egen kalender, inte
   type=date. Ett datumfält visar datumet i webbläsarens eller datorns format
   — 10/13/2026 med engelska som språk — och sidan kan inte styra det. Här
   finns det som går att räkna på utan DOM: tolkningen av det kunden skriver
   och veckorna i en månad. Kalendern själv står i ui/datepicker.js.
   -------------------------------------------------------------------------- */

const SEPARATED = /^(\d{4})[-./ ](\d{1,2})[-./ ](\d{1,2})$/;
const COMPACT   = /^(\d{4})(\d{2})(\d{2})$/;

/**
 * Det kunden skrev som "ÅÅÅÅ-MM-DD", eller null när det inte är ett datum.
 * Året står alltid först, som i Sverige: 2026-03-12, 2026-3-12, 2026.03.12
 * och 20260312 går, 12/3/2026 inte — det kan läsas på två sätt.
 * Ett datum som inte finns, 2026-02-30, är inget datum.
 */
export function parseDateText(text){
  const s = typeof text === 'string' ? text.trim() : '';
  const m = s.match(SEPARATED) || s.match(COMPACT);
  if(!m) return null;
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  const t = new Date(Date.UTC(y, mo - 1, d));
  if(t.getUTCFullYear() !== y || t.getUTCMonth() !== mo - 1 || t.getUTCDate() !== d) return null;
  return `${m[1]}-${String(mo).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
}

/** Datumet inom [min, max]: före filens första dag blir första dagen, efter sista blir sista. */
export function clampDay(iso, min, max){
  if(min && iso < min) return min;
  if(max && iso > max) return max;
  return iso;
}

/** Flyttar "ÅÅÅÅ-MM" n månader. */
export function shiftMonth(ym, n){
  const [y, m] = ym.split('-').map(Number);
  const t = new Date(Date.UTC(y, m - 1 + n, 1));
  return t.toISOString().slice(0, 7);
}

/**
 * Samma dag n månader bort, eller månadens sista dag när dagen inte finns
 * där: 31 januari plus en månad är 28 eller 29 februari.
 */
export function shiftMonthDay(iso, n){
  const ym = shiftMonth(iso.slice(0, 7), n);
  const [y, m] = ym.split('-').map(Number);
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${ym}-${String(Math.min(Number(iso.slice(8, 10)), last)).padStart(2,'0')}`;
}

/**
 * Månadens veckor, måndag först: en rad per vecka med sju platser, där en
 * plats är "ÅÅÅÅ-MM-DD" eller null för en dag i månaden före eller efter.
 */
export function monthGrid(ym){
  const [y, m] = ym.split('-').map(Number);
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const lead = (new Date(Date.UTC(y, m - 1, 1)).getUTCDay() + 6) % 7;
  const cells = Array(lead).fill(null);
  for(let d = 1; d <= days; d++) cells.push(`${ym}-${String(d).padStart(2,'0')}`);
  while(cells.length % 7) cells.push(null);
  const weeks = [];
  for(let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}
